export const ENVIRONMENT = Object.freeze({
  DEV: 'dev',
  QA: 'qa',
  STG: 'stg',
  PRD: 'prd',
});

export const DOMAIN_NAME: Record<string, string> = {
  [ENVIRONMENT.DEV]: 'operation-hps-dev.7ffcb144715e.use1.aws.optum.com',
  [ENVIRONMENT.QA]: 'operation-hps-qa.7ffcb144715e.use1.aws.optum.com',
  [ENVIRONMENT.STG]: 'operation-hps-stg.05a6b2de52bc.use1.aws.optum.com',
  [ENVIRONMENT.PRD]: 'operation-hps-prd.mednethps.prd.optum.com',
};

export const PUBLIC_DOMAIN_NAME: Record<string, string> = {
  [ENVIRONMENT.DEV]: 'ai-assistant-hps-dev.optum.com',
  [ENVIRONMENT.QA]: 'ai-assistant-hps-qa.optum.com',
  [ENVIRONMENT.STG]: 'ai-assistant-hps-stg.optum.com',
  [ENVIRONMENT.PRD]: 'ai-assistant-hps-prd.optum.com',
};

export const getEnvironment = (): string => {
  const hostname = window.location.hostname;

  if (hostname === 'localhost') {
    return ENVIRONMENT.DEV;
  }

  for (const domains of [DOMAIN_NAME, PUBLIC_DOMAIN_NAME]) {
    for (const [env, domain] of Object.entries(domains)) {
      if (hostname === domain || hostname.endsWith(`.${domain}`)) {
        return env;
      }
    }
  }

  return ENVIRONMENT.DEV;
};
